function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState, useEffect, useRef } from 'react';
// @ts-ignore
import { SystemCloseLargeLine } from '@m-ui/icons';
import VirtualList from 'rc-virtual-list';
import clearIcon from "../../assets/clear-no-read.png";
import Empty from "../Empty";
import MessageCard from "../MessageCard";
import { toInstanceLog } from "../../utils/log";
import { sleep } from "../../utils/index";
import Switch from "../custom-antd/Switch";
import Spin from "../custom-antd/Spin";
import message from "../custom-antd/Message";
import Tag from "../custom-antd/Tag";
import Setting from "../Setting";
import Drawer from "../custom-antd/Drawer";
import { EMessageReadStatus } from "../../type";
import { getMessageTabList, getMessageList, readMessage, readAllMessage } from "../../service";
import { DEFAULT_TAB_CODE, DEFAULT_CURRENT_PAGE, STYLE_PREFIX, NO_MORE } from "../../utils/const";
import "./style.less";
var Message = function Message(_ref) {
  var system = _ref.system,
    Weblog = _ref.Weblog,
    userId = _ref.userId,
    isShowMessage = _ref.isShowMessage,
    unReadCountList = _ref.unReadCountList,
    setIsShowMessage = _ref.setIsShowMessage,
    toGetUnreadInfo = _ref.toGetUnreadInfo;
  var weblogInstance = toInstanceLog(Weblog);
  // 列表容器ref
  var listRef = useRef(null);
  // 消息列表
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    messageList = _useState2[0],
    setMessageList = _useState2[1];
  // 消息tab列表
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    mesaageTabList = _useState4[0],
    setMessageTabList = _useState4[1];
  // 是否消息列表加载中
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isLoading = _useState6[0],
    setIsLoading = _useState6[1];
  // 是否未读模式
  var _useState7 = useState(EMessageReadStatus.ALL),
    _useState8 = _slicedToArray(_useState7, 2),
    messageReadStatus = _useState8[0],
    setMessageReadStatus = _useState8[1];
  // 当前选中的tab
  var _useState9 = useState(''),
    _useState10 = _slicedToArray(_useState9, 2),
    activeTab = _useState10[0],
    setActiveTab = _useState10[1];
  // 消息列表当前页
  var _useState11 = useState(DEFAULT_CURRENT_PAGE),
    _useState12 = _slicedToArray(_useState11, 2),
    currentPage = _useState12[0],
    setCurrentPage = _useState12[1];
  // 列表容器高度
  var _useState13 = useState(800),
    _useState14 = _slicedToArray(_useState13, 2),
    listWrapperHeight = _useState14[0],
    setlistWrapperHeight = _useState14[1];
  var onSwitchChange = function onSwitchChange(val) {
    sendLogsClickButton(val ? 'TURN_ON_ONLY_CHECK_UNREAD' : 'TURN_OFF_ONLY_CHECK_UNREAD');
    setMessageReadStatus(val ? EMessageReadStatus.UNREAD : EMessageReadStatus.ALL);
  };
  var onScroll = function onScroll(e) {
    var _ref2 = e === null || e === void 0 ? void 0 : e.currentTarget,
      scrollHeight = _ref2.scrollHeight,
      scrollTop = _ref2.scrollTop;
    // 距离底部300px加载下一页数据
    if (isLoading || currentPage === NO_MORE || scrollHeight - listWrapperHeight - scrollTop > 300) {
      return;
    }
    toGetMessageList(currentPage);
  };

  /**
   * 渲染未读数
   * @param label
   * @returns
   */
  var renderUnRead = function renderUnRead(label) {
    var i = unReadCountList === null || unReadCountList === void 0 ? void 0 : unReadCountList.find(function (item) {
      return item.primaryLabel === label;
    });
    if (i) {
      return i.unreadMsgCount > 0 ? i.unreadMsgCount < 100 ? "(".concat(i.unreadMsgCount, ")") : '(99+)' : '';
    }
    return '';
  };

  /**
   * 已读单条消息
   * @param id
   */
  var toReadMessage = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(id) {
      var lastMessageList, _lastMessageList;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            lastMessageList = messageList.map(function (item) {
              return _objectSpread(_objectSpread({}, item), {}, {
                readStatus: item.id === id ? EMessageReadStatus.READ : item.readStatus
              });
            });
            setMessageList(lastMessageList);
            _context.next = 5;
            return readMessage({
              messageId: id
            }, system);
          case 5:
            _context.next = 7;
            return sleep(1);
          case 7:
            toGetUnreadInfo();
            _context.next = 15;
            break;
          case 10:
            _context.prev = 10;
            _context.t0 = _context["catch"](0);
            console.log(_context.t0);
            _lastMessageList = messageList.map(function (item) {
              return _objectSpread(_objectSpread({}, item), {}, {
                readStatus: item.id === id ? EMessageReadStatus.UNREAD : item.readStatus
              });
            });
            setMessageList(_lastMessageList);
          case 15:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 10]]);
    }));
    return function toReadMessage(_x2) {
      return _ref3.apply(this, arguments);
    };
  }();

  /**
   * 已读全部消息
   */
  var toReadAllMessage = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            _context2.next = 3;
            return readAllMessage(system);
          case 3:
            setCurrentPage(DEFAULT_CURRENT_PAGE);
            toGetMessageList(DEFAULT_CURRENT_PAGE);
            _context2.next = 7;
            return sleep(1);
          case 7:
            toGetUnreadInfo();
            message.info({
              content: '已将全部消息置为已读状态'
            });
            sendLogsClickButton('CLEAR_UNREAD');
            _context2.next = 16;
            break;
          case 12:
            _context2.prev = 12;
            _context2.t0 = _context2["catch"](0);
            console.log(_context2.t0);
            message.error({
              content: '全部消息置为已读状态失败'
            });
          case 16:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[0, 12]]);
    }));
    return function toReadAllMessage() {
      return _ref4.apply(this, arguments);
    };
  }();

  /**
   * 获取消息Tab列表
   */
  var toGetMessageTabList = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
      var tab;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _context3.prev = 0;
            _context3.next = 3;
            return getMessageTabList(system);
          case 3:
            tab = _context3.sent;
            setMessageTabList(tab);
            // tab默认选中全部
            setActiveTab(DEFAULT_TAB_CODE);
            _context3.next = 11;
            break;
          case 8:
            _context3.prev = 8;
            _context3.t0 = _context3["catch"](0);
            console.log(_context3.t0);
          case 11:
          case "end":
            return _context3.stop();
        }
      }, _callee3, null, [[0, 8]]);
    }));
    return function toGetMessageTabList() {
      return _ref5.apply(this, arguments);
    };
  }();

  /**
   * 获取消息列表
   * @param current 当前页
   */
  var toGetMessageList = /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(current) {
      var _yield$getMessageList, _message, pcursor;
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            _context4.prev = 0;
            setIsLoading(true);
            _context4.next = 4;
            return getMessageList({
              pcursor: current,
              primaryLabel: activeTab,
              readStatus: messageReadStatus
            }, system);
          case 4:
            _yield$getMessageList = _context4.sent;
            _message = _yield$getMessageList.message;
            pcursor = _yield$getMessageList.pcursor;
            setCurrentPage(pcursor);
            // 没有更多数据，用于显示没有更多文案
            if (_message.length && pcursor === NO_MORE) {
              _message.push({
                id: NO_MORE,
                secondLabelIcon: '',
                title: '',
                readStatus: '',
                content: '',
                secondLabelName: '',
                updateTime: '',
                buttonText: '',
                jumpUrl: ''
              });
            }
            setMessageList(current === DEFAULT_CURRENT_PAGE ? _message : messageList.concat(_message));
            _context4.next = 15;
            break;
          case 12:
            _context4.prev = 12;
            _context4.t0 = _context4["catch"](0);
            console.log(_context4.t0);
          case 15:
            _context4.prev = 15;
            setIsLoading(false);
            return _context4.finish(15);
          case 18:
          case "end":
            return _context4.stop();
        }
      }, _callee4, null, [[0, 12, 15, 18]]);
    }));
    return function toGetMessageList(_x3) {
      return _ref6.apply(this, arguments);
    };
  }();
  useEffect(function () {
    // 获取消息tab列表
    toGetMessageTabList();
  }, []);
  useEffect(function () {
    if (!activeTab) {
      return;
    }
    // tab变更，开始拉取消息列表
    setCurrentPage(DEFAULT_CURRENT_PAGE);
    toGetMessageList(DEFAULT_CURRENT_PAGE);
    // 当消息列表更新时，未读数同步更新
    toGetUnreadInfo();
  }, [activeTab, messageReadStatus]);
  useEffect(function () {
    if (isShowMessage) {
      var _listRef$current;
      sendLogsPV();
      var h = listRef === null || listRef === void 0 ? void 0 : (_listRef$current = listRef.current) === null || _listRef$current === void 0 ? void 0 : _listRef$current.offsetHeight;
      if (h) {
        setlistWrapperHeight(h);
      }
    }
  }, [isShowMessage]);
  useEffect(function () {
    if (!messageList.length) {
      return;
    }
    messageList.forEach(function (message) {
      var primaryLabelName = message.primaryLabelName,
        id = message.id,
        secondLabel = message.secondLabel,
        readStatus = message.readStatus,
        template_code = message.template_code;
      toSendLogs('show', {
        tab_name: primaryLabelName,
        notification_id: id,
        notification_type: secondLabel,
        is_unread: [EMessageReadStatus.READ, EMessageReadStatus.ALL_READ].includes(readStatus) ? 1 : 0,
        template_code: template_code
      });
    });
  }, [messageList]);

  /**
   * 页面曝光上报
   */
  var sendLogsPV = function sendLogsPV() {
    weblogInstance.PV({
      params: {
        merchant_user_id: userId
      },
      page: 'LOCALLIFE_WEB_MERCHANT_MESSAGE_NOTIFICATION'
    });
  };

  /**
   * 页面曝光/卡片点击上报
   */
  var toSendLogs = function toSendLogs(type, params) {
    var tab_name = params.tab_name,
      notification_id = params.notification_id,
      notification_type = params.notification_type,
      is_unread = params.is_unread,
      template_code = params.template_code;
    weblogInstance[type === 'click' ? 'CLICK' : 'SHOW']({
      action: 'NOTIFICATION_CARD',
      params: {
        merchant_user_id: userId,
        tab_name: tab_name,
        notification_id: notification_id,
        notification_type: notification_type,
        is_unread: is_unread,
        template_code: template_code
      }
    });
  };

  /**
   * 按钮点击上报
   */
  var sendLogsClickButton = function sendLogsClickButton(button_type) {
    weblogInstance.CLICK({
      action: 'OPERATION_BUTTON',
      params: {
        button_type: button_type
      }
    });
  };
  var _handleMessageClick = function handleMessageClick(_ref7) {
    var primaryLabelName = _ref7.primaryLabelName,
      id = _ref7.id,
      secondLabel = _ref7.secondLabel,
      readStatus = _ref7.readStatus,
      template_code = _ref7.template_code;
    if (readStatus === EMessageReadStatus.UNREAD) {
      toReadMessage(id);
    }
    toSendLogs('click', {
      tab_name: primaryLabelName,
      notification_id: id,
      notification_type: secondLabel,
      is_unread: [EMessageReadStatus.READ, EMessageReadStatus.ALL_READ].includes(readStatus) ? 1 : 0,
      template_code: template_code
    });
  };
  var handleSettingLog = function handleSettingLog() {
    sendLogsClickButton('NOTIFICATION_SETTING');
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Drawer, {
    isShow: isShowMessage,
    onClose: function onClose() {
      return setIsShowMessage(false);
    }
  }, /*#__PURE__*/React.createElement(Spin, {
    spinning: isLoading
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(STYLE_PREFIX, "message")
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(STYLE_PREFIX, "message-header")
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(STYLE_PREFIX, "drawn-title")
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(STYLE_PREFIX, "drawn-title-name")
  }, "\u6D88\u606F\u4E2D\u5FC3"), /*#__PURE__*/React.createElement("div", {
    className: "".concat(STYLE_PREFIX, "drawn-title-extra"),
    onClick: toReadAllMessage
  }, /*#__PURE__*/React.createElement("img", {
    className: "clear-icon",
    src: clearIcon
  }), /*#__PURE__*/React.createElement("div", {
    className: "".concat(STYLE_PREFIX, "drawn-title-extra-desc")
  }, "\u6E05\u9664\u672A\u8BFB"))), /*#__PURE__*/React.createElement("div", {
    className: "drawn-extra"
  }, /*#__PURE__*/React.createElement("div", {
    className: "read-only-wrapper"
  }, /*#__PURE__*/React.createElement("span", {
    className: "label"
  }, "\u53EA\u770B\u672A\u8BFB"), /*#__PURE__*/React.createElement(Switch, {
    onChange: onSwitchChange
  })),
  // 仅在商家展示设置按钮
  system === 'merchant' ? /*#__PURE__*/React.createElement(Setting, {
    log: handleSettingLog
  }) : null, /*#__PURE__*/React.createElement(SystemCloseLargeLine, {
    style: {
      marginLeft: '32px'
    },
    onClick: function onClick() {
      return setIsShowMessage(false);
    },
    className: "close_icon pointer"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "".concat(STYLE_PREFIX, "message-tab")
  }, /*#__PURE__*/React.createElement(React.Fragment, null, mesaageTabList.map(function (tab) {
    return /*#__PURE__*/React.createElement(Tag, {
      content: "".concat(tab.name).concat(renderUnRead(tab.label)),
      isCheck: activeTab === tab.label,
      onChange: function onChange() {
        return setActiveTab(tab.label);
      }
    });
  }))), /*#__PURE__*/React.createElement("div", {
    className: "".concat(STYLE_PREFIX, "message-content")
  }, messageList.length ? /*#__PURE__*/React.createElement("div", {
    ref: listRef,
    className: "list-wrapper"
  }, /*#__PURE__*/React.createElement(VirtualList, {
    data: messageList,
    itemKey: "id",
    height: listWrapperHeight,
    onScroll: onScroll
  }, function (item) {
    return item.id === NO_MORE ? /*#__PURE__*/React.createElement("div", {
      className: "no_more"
    }, "\u6CA1\u6709\u66F4\u591A\u5566") : /*#__PURE__*/React.createElement(MessageCard, {
      mesaage: item,
      readMessage: toReadMessage,
      handleMessageClick: function handleMessageClick() {
        return _handleMessageClick(item);
      }
    });
  })) : /*#__PURE__*/React.createElement(Empty, null))))));
};
export default Message;